import type { OfferVM, FirmVM } from "./types";
import { officialUrlForSlug } from "../config/propFirmLinks";

const UTM: Record<string, string> = {
  utm_source: "edgely",
  utm_medium: "comparator",
  utm_campaign: "affiliate",
};

/**
 * Parse a URL, accepting ONLY http/https — `new URL()` does NOT reject
 * `javascript:`/`data:` schemes, which would be a stored-XSS vector once rendered
 * into an <a href>, so we enforce a protocol allowlist (defence in depth alongside
 * the server-side check).
 */
function parseHttpUrl(raw: string): URL | null {
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  return url.protocol === "http:" || url.protocol === "https:" ? url : null;
}

/**
 * Resolve the "Démarrer le challenge" destination for an offer.
 * Priority:
 *   1. offer.affiliateUrl → firm.affiliateUrl (admin-entered, DB) — UTM appended.
 *   2. official URL from the propFirmLinks config, by firm slug — no UTM (plain site).
 *   3. null — the button renders disabled.
 */
export function buildAffiliateUrl(offer: OfferVM, firm: FirmVM): string | null {
  const affiliateBase = offer.affiliateUrl ?? firm.affiliateUrl;
  if (affiliateBase) {
    const url = parseHttpUrl(affiliateBase);
    if (url) {
      for (const [k, v] of Object.entries(UTM)) url.searchParams.set(k, v);
      url.searchParams.set("utm_content", `${offer.id}-${firm.slug}`);
      return url.toString();
    }
  }
  // Fallback: official firm site from config (no affiliate params).
  const official = officialUrlForSlug(firm.slug);
  if (official) {
    const url = parseHttpUrl(official);
    if (url) return url.toString();
  }
  return null;
}
